import type { GetCustomerMasterReportResponse } from '@vy/api-definition';
import { GetCustomerMasterReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useCustomerMasterReport(
  options?: CustomUseQueryOptions<GetCustomerMasterReportResponse>,
) {
  const getCustomerMasterReportQuery = useQuery(
    queryKeys.customerMasterReport(),
    async () => {
      const api = getPrivateApi();
      const response = await api.getCustomerMasterReportRaw();
      const json = await response.raw.json();

      return GetCustomerMasterReportResponseSchema.parse(json);
    },
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(getCustomerMasterReportQuery.data, 'getCustomerMasterReportQuery data');

  return getCustomerMasterReportQuery;
}
